import { useSnapshot } from "valtio";
import { serverLogTexts } from "@/locales/server-log";
import { i18nStore } from "@/store/i18n";

/** Teks Server Log sesuai bahasa UI (id/en). */
export function useServerLogText() {
	const { lang } = useSnapshot(i18nStore);
	return serverLogTexts[lang === "en" ? "en" : "id"];
}
